import { useDispatch } from 'react-redux';

import { addCategoryFilter, removeCategoryFilter } from '../../../../store/slices/catalogSlice';
import styles from './styles.module.scss';

const FilterCheckbox = (props) => {
    const { name, id, isChecked } = props;
    const dispatch = useDispatch();

    const setCategoryFilters = (e) => {
        const id = e.target.id;
        e.target.checked ? dispatch(addCategoryFilter({ filters: id })) : dispatch(removeCategoryFilter(id));
    };

    return (
        <li className={styles.item}>
            <div className={styles.checkbox}>
                <input type="checkbox" id={id} onChange={(e) => setCategoryFilters(e)} checked={isChecked} />
                <label htmlFor={id}>
                    <span></span>
                    {name}
                </label>
            </div>
        </li>
    );
};

export default FilterCheckbox;
